import { useEffect, useRef } from "react";

import { HighlightTarget } from "@/components/Account/payment/payment.utils";

/**
 * `?reason=` from an email names a block (PayoutBlockerFamily): scroll to it
 * once the page has rendered. The blocks themselves draw the highlight ring.
 */
export const useReasonHighlight = (
  highlight: HighlightTarget,
  ready: boolean
) => {
  const tasksRef = useRef<HTMLElement>(null);
  const bankRef = useRef<HTMLElement>(null);
  const scrolledRef = useRef(false);

  useEffect(() => {
    if (scrolledRef.current || !ready) {
      return;
    }

    const target =
      highlight === "tasks"
        ? tasksRef.current
        : highlight === "bank"
        ? bankRef.current
        : null;

    if (target) {
      scrolledRef.current = true;
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [highlight, ready]);

  return { tasksRef, bankRef };
};
